import { render, staticRenderFns } from "./DailyBoxUpdate.vue?vue&type=template&id=cc6f2208&scoped=true&"
import script from "./DailyBoxUpdate.vue?vue&type=script&lang=js&"
export * from "./DailyBoxUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6f2208",
  null
  
)

export default component.exports